var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1478 156L1478 184",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1478.5,
    cy: 151.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.08 156.222H1479.92V152.917H1483.22V150.083H1479.92V146.778H1477.08V150.083H1473.78V152.917H1477.08V156.222ZM1471.89 160C1471.37 160 1470.92 159.815 1470.55 159.445C1470.18 159.075 1470 158.631 1470 158.111V144.889C1470 144.369 1470.18 143.925 1470.55 143.555C1470.92 143.185 1471.37 143 1471.89 143H1485.11C1485.63 143 1486.08 143.185 1486.45 143.555C1486.82 143.925 1487 144.369 1487 144.889V158.111C1487 158.631 1486.82 159.075 1486.45 159.445C1486.08 159.815 1485.63 160 1485.11 160H1471.89ZM1471.89 158.111H1485.11V144.889H1471.89V158.111Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital1);
export default __webpack_public_path__ + "static/media/hospital_1.b2db950e860431f50254c34ceeefc478.svg";
export { ForwardRef as ReactComponent };